export const ERROR = 'ERROR'
export const LOGIN = 'LOGIN'
export const INITIALISED = 'INITIALISED'
export const LOGOUT = 'LOGOUT'
export const GUEST = 'GUEST'
